import { Stack, Typography } from '@mui/material'
import { C1IconButton } from 'c1ui'
import { C1EmptyIndicator } from 'components/core/empty-indicator/C1EmptyIndicator'
import { C1Icon } from 'components/core/icons/C1Icon'
import { Eye, EyeOff } from 'lucide-react'
import { FC, useState } from 'react'

export const RenderPassword: FC<{ value: string }> = ({ value }) => {
    const [showPassword, setShowPassword] = useState(false)
    const dotPlaceholder = '•'.repeat(value?.length || 0)

    if (!value || value.length === 0) {
        return <C1EmptyIndicator />
    }

    return <Stack direction="row" spacing={1} alignItems="center">
        <Typography variant="monospace">{showPassword ? value : dotPlaceholder}</Typography>
        <C1IconButton onClick={(): void => setShowPassword(!showPassword)} aria-label="toggle password visibility" size="small">
            {showPassword ? <C1Icon icon={EyeOff} /> : <C1Icon icon={Eye} />}
        </C1IconButton>
    </Stack>
}
